<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    v-model="show"
    width="900"
    :fullscreen="$vuetify.display.width <= 600 ? true : false"
    class="public-style"
    destroy-on-close
    align-center
    @close="close"
  >
    <el-form
      ref="ruleFormRef"
      :model="uploadData"
      :style="[$vuetify.display.width < 600 ? 'height: 550;' : '']"
      :label-position="`top`"
    >
      <el-space fill style="width: 100%">
        <!-- User Information Section -->
        <el-alert type="info" class="alert-style" show-icon :closable="false">
          <p class="ma-0 text-white">Charger Schedule Upload Details</p>
        </el-alert>
        
        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="user_full_name" label="User Full Name:">
              <el-input v-model="uploadData.user_full_name" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="user_email" label="User Email:">
              <el-input v-model="uploadData.user_email" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="form_kind" label="Form Kind:">
              <el-input v-model="uploadData.form_kind" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="action_kind" label="Action Kind:">
              <el-input v-model="uploadData.action_kind" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="document_id" label="Document ID:">
              <el-input v-model="uploadData.document_id" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="log_date" label="Log Date:">
              <el-input :value="formatDateTime(uploadData.log_date)" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="created_at" label="Created At:">
              <el-input :value="formatDateTime(uploadData.created_at)" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item class="label-style" prop="comment" label="Comment:">
              <el-input v-model="uploadData.comment" type="textarea" :rows="2" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- Upload Response Section -->
        <el-alert type="warning" class="alert-style" show-icon :closable="false">
          <p class="ma-0 text-white">Upload Response Details</p>
        </el-alert>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="request_from_api" label="Request From API:">
              <el-tag :type="beforeChangeData.request_from_api ? 'success' : 'info'">
                {{ beforeChangeData.request_from_api ? 'Yes' : 'No' }}
              </el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="code" label="Response Code:">
              <el-tag :type="getCodeTagType(beforeChangeData.code)">
                {{ beforeChangeData.code }}
              </el-tag>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item class="label-style" prop="message" label="Response Message:">
              <el-input 
                v-model="beforeChangeData.message" 
                type="textarea" 
                :rows="4" 
                readonly 
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- Duplicates Section -->
        <template v-if="duplicateItems.length > 0">
          <el-alert type="error" class="alert-style" show-icon :closable="false">
            <p class="ma-0 text-white">Duplicate Records ({{ duplicateItems.length }})</p>
          </el-alert>
          
        <div class="custom-table-design">
          <el-table :data="duplicateItems" stripe style="width: 100%" max-height="250" class="my-2 data-table"
          scrollbar-always-on: false>
            <el-table-column prop="site_name" label="Site Name" min-width="150" />
            <el-table-column prop="charger_id" label="Charger ID" min-width="280" />
            <el-table-column prop="port_id" label="Port ID" min-width="80" />
            <el-table-column prop="operational_date" label="Operational Date" min-width="120" />
          </el-table>
        </div>
        </template>

        <!-- Invalid Site Data Section -->
        <template v-if="beforeChangeData.data && beforeChangeData.data.invalid_site_data">
          <el-alert type="error" class="alert-style mt-3" show-icon :closable="false">
            <p class="ma-0 text-white">Invalid Site Data</p>
          </el-alert>
          <el-input 
            :value="beforeChangeData.data.invalid_site_data" 
            type="textarea" 
            :rows="3" 
            readonly 
          />
        </template>

        <!-- Invalid Charger Data Section -->
        <template v-if="beforeChangeData.data && beforeChangeData.data.invalid_charger_data">
          <el-alert type="error" class="alert-style mt-3" show-icon :closable="false">
            <p class="ma-0 text-white">Invalid Charger Data</p>
          </el-alert>
          <el-input 
            :value="beforeChangeData.data.invalid_charger_data" 
            type="textarea" 
            :rows="3" 
            readonly 
          />
        </template>

        <!-- Invalid Port Data Section -->
        <template v-if="beforeChangeData.data && beforeChangeData.data.invalid_port_data">
          <el-alert type="error" class="alert-style mt-3" show-icon :closable="false">
            <p class="ma-0 text-white">Invalid Port Data</p>
          </el-alert>
          <el-input 
            :value="beforeChangeData.data.invalid_port_data" 
            type="textarea" 
            :rows="3" 
            readonly 
          />
        </template>

        <!-- No Issues Section -->
        <template v-if="hasNoIssues">
          <el-alert type="success" class="alert-style mt-3" show-icon :closable="false">
            <p class="ma-0 text-white">No duplicate or invalid data detected</p>
          </el-alert>
        </template>

      </el-space>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="medium"
          class="me-primary"
          @click.stop="close"
          color="#ddf0ac"
        >
          <i class="fa fa-times me-2 me-primary"></i>
          <span class="moderat-btn-apply">Close</span>
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    open_modal: {
      type: Boolean,
      default: false,
    },
    data_modal: {
      type: Object,
      // eslint-disable-next-line no-unused-vars
      default(rawProps) {
        return {};
      },
    },
  },
  data() {
    return {
      show: this.open_modal,
      uploadData: {
        id: 0,
        log_date: "",
        form_kind: "",
        action_kind: "",
        document_id: "",
        comment: "",
        user_id: 0,
        user_full_name: "",
        user_email: "",
        created_at: "",
        updated_at: "",
        before_change: "",
      },
      beforeChangeData: {
        request_from_api: false,
        code: 0,
        message: "",
        data: {
          duplicate: null,
          invalid_site_data: null,
          invalid_charger_data: null,
          invalid_port_data: null,
        },
      },
    };
  },
  computed: {
    duplicateItems() {
      if (!this.beforeChangeData.data || !this.beforeChangeData.data.duplicate) {
        return [];
      }
      const duplicateStr = this.beforeChangeData.data.duplicate;
      const items = duplicateStr.split("|<:>|").filter(item => item.trim());
      
      return items.map(item => {
        const parts = item.split(";");
        return {
          site_name: parts[0] || "",
          charger_id: parts[1] || "",
          port_id: parts[2] || "",
          operational_date: parts[3] || "",
        };
      });
    },
    hasNoIssues() {
      if (!this.beforeChangeData.data) return true;
      const data = this.beforeChangeData.data;
      return !data.duplicate && 
             !data.invalid_site_data && 
             !data.invalid_charger_data && 
             !data.invalid_port_data;
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    open_modal: function (newVal, oldVal) {
      this.show = newVal;
      if (newVal === true) {
        this.parseModalData();
      }
    },
  },
  methods: {
    parseModalData() {
      if (this.data_modal) {
        // Handle both string and object input
        const data = typeof this.data_modal === 'string' 
          ? JSON.parse(this.data_modal) 
          : this.data_modal;
        
        this.uploadData = { ...data };
        
        // Parse the before_change JSON string
        if (data.before_change) {
          try {
            this.beforeChangeData = typeof data.before_change === 'string'
              ? JSON.parse(data.before_change)
              : data.before_change;
          } catch (e) {
            console.error("Error parsing before_change:", e);
            this.beforeChangeData = {
              request_from_api: false,
              code: 0,
              message: "Error parsing response data",
              data: {},
            };
          }
        }
      }
    },
    formatDateTime(dateStr) {
      if (!dateStr) return "";
      try {
        const date = new Date(dateStr);
        return date.toLocaleString("en-AU", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });
      } catch (e) {
        return dateStr;
      }
    },
    getCodeTagType(code) {
      if (code === 200) return "success";
      if (code >= 400 && code < 500) return "warning";
      if (code >= 500) return "danger";
      return "info";
    },
    close() {
      this.show = false;
      this.$emit("close_modal", false);
    },
  },
};
</script>

<style scoped>
.el-dialog__body {
  padding: 30px 10px;
}

.el-input__inner {
  padding: 0 10px !important;
}

::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.el-form-item__label {
  margin-bottom: 0 !important;
}

.el-form-item__content > .el-checkbox {
  margin-top: 16px;
  margin-bottom: 0;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.mt-3 {
  margin-top: 12px;
}

.alert-style {
  margin-bottom: 10px;
}

</style>
